import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../../redux';
import { updateCommonSettings } from '../../../redux/board/reducer';
import { setIsContentChange } from '../../../redux/stateManager/reducer';
import { getCommonSettings, eventBus, getCurrentState } from '../../../utils';

export default () => {
  const dispatch = useDispatch();
  const commonSettings = useSelector((appState) => appState.board.commonSettings);
  const [state, _setState] = useState({
    canvas: null,
  });

  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));

  const initCanvas = (canvas) => setState({ canvas });

  const onModifyCommoneSettings = (obj, type, events) => {
    if (obj) {
      const coords = getCommonSettings(obj, type, events, commonSettings);
      dispatch(updateCommonSettings({ ...coords, valueChange: undefined }));
    }
  };

  const onModified = (e) => {
    const obj = state.canvas.getActiveObject();
    onModifyCommoneSettings(obj, e.action, e);
  };
  useEffect(() => {
    if (state.canvas) {
      state.canvas.on('object:modified', onModified);
    }
    return () => {
      if (state.canvas) {
        state.canvas.off('object:modified', onModified);
      }
    };
  }, [state.canvas, commonSettings]);

  const setFlipAction = (action) => {
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    const obj = state.canvas.getActiveObject();
    obj.set({ [action]: !obj[action] });
    state.canvas.renderAll();
    dispatch(actions.updatePageContent(getCurrentState()));
  };
  const onTransformChange = (data) => {
    if (state.canvas) {
      const obj = state.canvas.getActiveObject();
      if (!obj) return;
      if ('angle' in data) {
        obj.rotate(data.angle);
        state.canvas.renderAll();
        dispatch(actions.updatePageContent(getCurrentState()));
        return;
      }
      obj.set(data);
      state.canvas.renderAll();
      dispatch(actions.updatePageContent(getCurrentState()));
    }
  };
  useEffect(() => {
    eventBus.on('action-flip', setFlipAction);
    eventBus.on('on-transform-change', onTransformChange);
    return () => {
      eventBus.off('action-flip', setFlipAction);
      eventBus.off('on-transform-change', onTransformChange);
    };
  });
  return {
    initCanvas,
  };
};
